function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "my vector image");

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Layer 1");

var SvgBiscuitDough = function SvgBiscuitDough(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.60747636063195,
    height: 27.86915878687728,
    viewBox: "0 0 29.60747636063195 27.86915878687728",
    className: "biscuit-dough-svg",
    style: {},
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    className: "currentLayer"
  }, _ref3, /*#__PURE__*/React.createElement("path", {
    fill: "#dadada",
    fillOpacity: 1,
    stroke: "#222222",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_4",
    d: "M101.97224869051944,186.3555011839844 ",
    style: {
      color: "rgb(210, 180, 140)"
    },
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2b48c",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDashoffset: "",
    fillRule: "nonzero",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_7",
    d: "M27.35477740027187,23.615226942385334 C23.11492185239959,27.855082490257274 16.556125295204424,28.718524979629535 11.363408600116571,25.72064161927625 C6.170691905028576,22.722567777302658 3.6390131927735183,16.61068826931819 5.190939916056095,10.818958514122272 C6.74287287004728,5.027267923370886 11.991309888659629,0.9999987612592065 17.987270651390105,0.9999987612592065 L27.35477740027187,23.615227832485346 L27.35477740027187,23.615226942385334 z",
    style: {
      color: "rgb(210, 180, 140)"
    },
    className: "",
    transform: "rotate(112.3167724609375 16.046546936035153,14.24786949157715) ",
    fillOpacity: 1
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBiscuitDough, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/biscuit-dough.8b0a4b98.svg";
export { ForwardRef as ReactComponent };